import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, TextField, Button, Stack, Link as MUILink } from "@mui/material";
import { toast } from "react-toastify";

import useUser from "../hooks/user";
import LoginFooter from "../components/loginFooter";
import logo from "../assets/img/smartTrail.svg";

export default function ForgotPassword() {
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState("");

  const user = useUser();

  const handleSubmit = (e) => {
    e.preventDefault();

    // Simple email check; HTML5 validation on TextField also helps.
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;

    if (!email || !re.test(email)) {
      setError("Please enter a valid email address.");
      toast.error("Invalid Email Address");
      return;
    }

    setError("");
    user.actions.forgot_password(email);
    toast.success("If the email exists, a reset link will be sent.");
  };

  return (
    <Box
      sx={{
        bgcolor: "#fcf6f6",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          flex: "1 0 auto",
          display: "flex",
          py: 0,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "100%",
            p: { xs: 3, md: 4 },
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 3,
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="SmartTrail"
            sx={{ height: 48, display: "block", mb: 4 }}
          />

          <Box component="form" noValidate onSubmit={handleSubmit}>
            <Stack spacing={2.5}>
              <TextField
                type="email"
                label="Email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                error={Boolean(error)}
                helperText={error || " "}
              />

              <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "stretch", sm: "center" }}
                spacing={2}
              >
                <MUILink
                  component={RouterLink}
                  to="/login"
                  underline="hover"
                  sx={{ fontWeight: 600 }}
                >
                  Back to Login
                </MUILink>

                <Button variant="contained" type="submit">
                  Send Reset Link
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Box>
      </Container>

      <LoginFooter />
    </Box>
  );
}
